import React from 'react';
import { FormikCountry, FormikField } from '@components/formik';
import { MenuItem, Typography } from '@mui/material';
import { useField } from 'formik';
//
import ObTooltip from './ObTooltip';

const BusinessDetails: React.FC = () => {
  const [f, _, meta] = useField('website');

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    let { value } = event.target;
    if (value) {
      meta.setError(
        'Invalid (Ex: https://www.example.com or https://example.com)'
      );

      // Prepend "https://" only if the URL doesn't already start with "http://" or "https://"
      if (!value.startsWith('http://') && !value.startsWith('https://')) {
        value = `https://${value}`;
      }
      meta.setValue(value);

      // Validate the corrected URL
      const regex =
        /^(https?:\/\/)+(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*?.?[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/;
      console.log(regex.test(value));
      if (!regex.test(value)) {
        console.log('test');
        meta.setError(
          'Invalid (Ex: https://www.example.com or https://example.com)'
        );
        meta.setTouched(true);
      } else {
        meta.setError(undefined);
      }
    }
  };

  return (
    <>
      <Typography variant="h4" component="h2" gutterBottom>
        Tell us more about your business
      </Typography>
      <Typography variant="body1" gutterBottom color="text.secondary">
        {import.meta.env.VITE_SITE} collects this information to better
        understand and serve your business.
      </Typography>

      <ObTooltip title="The name you provide must exactly match the name associated with your business number (BN).">
        <FormikField
          name="businessName"
          label="Legal business name"
          placeholder="Company, Inc."
        />
      </ObTooltip>

      <FormikField
        name="businessNumber"
        label="Business number (BN) or Québec Enterprise Number (NEQ)"
        placeholder="123456789"
        allowType="number"
        limitChars={30}
      />

      <FormikCountry name="businessCountry" maxHeight={224} />

      <ObTooltip
        title="If you don’t have a website, enter a social media page, LinkedIn, or
        other relevant link."
      >
        <FormikField
          onBlur={handleBlur}
          name="website"
          label="Business website"
          placeholder="https://example.com"
        />
      </ObTooltip>

      <ObTooltip title="Provide a 1-2 sentence description. Make sure to note when you typically charge your customers (i.e. during checkout or 3 days later). This helps us better understand your business.">
        <FormikField
          name="description"
          label="Product description"
          placeholder="Describe your product or service"
          multiline
          rows={3}
        />
      </ObTooltip>
    </>
  );
};

export default BusinessDetails;
